var _rect, _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsBgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 388,
    viewBox: "0 0 360 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24303_21508",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 14,
    width: 360,
    height: 222
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 360,
    height: 222,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24303_21508)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_24303_21508",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -46,
    width: 362,
    height: 241
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 -46H-1V195H360.5V-46Z",
    fill: "#6BB6F7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_24303_21508)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M185.296 220.903H173.202L147.767 -86.5547H210.736L185.296 220.903Z",
    fill: "url(#paint0_linear_24303_21508)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M167.852 221.85L156.491 225.986L27.4307 -54.2299L86.601 -75.7656L167.852 221.85Z",
    fill: "url(#paint1_linear_24303_21508)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M151.787 228.694L142.518 236.469L-74.5942 17.2938L-26.3605 -23.1797L151.787 228.694Z",
    fill: "url(#paint2_linear_24303_21508)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M139.028 240.631L132.979 251.105L-146.003 119.408L-114.519 64.875L139.028 240.631Z",
    fill: "url(#paint3_linear_24303_21508)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M190.645 221.85L202.01 225.986L331.07 -54.2299L271.9 -75.7656L190.645 221.85Z",
    fill: "url(#paint4_linear_24303_21508)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M206.715 228.694L215.979 236.469L433.096 17.2938L384.862 -23.1797L206.715 228.694Z",
    fill: "url(#paint5_linear_24303_21508)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M219.475 240.631L225.519 251.105L504.505 119.408L473.021 64.875L219.475 240.631Z",
    fill: "url(#paint6_linear_24303_21508)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.09138 35.6896C-2.10352 35.4673 -4.6189 32.9962 -4.8819 29.805L-5.19056 26.1498L-5.59145 26.1528L-5.84544 29.8122C-6.06774 33.0071 -8.53882 35.5225 -11.7301 35.7854L-15.3852 36.0941L-15.3822 36.495L-11.7229 36.749C-8.52799 36.9713 -6.01261 39.4424 -5.74962 42.6336L-5.44096 46.2888L-5.04007 46.2858L-4.78607 42.6264C-4.56378 39.4315 -2.09269 36.9162 1.09858 36.6532L4.75372 36.3445L4.75073 35.9436L1.09138 35.6896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7047 139.925C9.67083 139.786 8.06934 138.208 7.89941 136.176L7.70617 133.85L7.45294 133.851L7.2945 136.181C7.15495 138.215 5.57722 139.816 3.54565 139.986L1.21882 140.18L1.22071 140.433L3.55017 140.591C5.58406 140.731 7.18555 142.308 7.35548 144.34L7.54872 146.667L7.80194 146.665L7.96039 144.335C8.09993 142.302 9.67766 140.7 11.7092 140.53L14.0361 140.337L14.0342 140.084L11.7047 139.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.373 78.8394C324.339 78.6998 322.737 77.1221 322.567 75.0905L322.374 72.7637L322.121 72.7656L321.962 75.095C321.823 77.1289 320.245 78.7304 318.214 78.9003L315.887 79.0936L315.889 79.3468L318.218 79.5052C320.252 79.6448 321.854 81.2225 322.023 83.2541L322.217 85.5809L322.47 85.579L322.628 83.2496C322.768 81.2157 324.346 79.6142 326.377 79.4443L328.704 79.251L328.702 78.9978L326.373 78.8394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7024 97.8131C53.4919 97.7307 52.5424 96.7952 52.4419 95.5861L52.3258 94.1731L52.0726 94.175L51.9776 95.5896C51.8953 96.8 50.9598 97.7496 49.7507 97.8501L48.3377 97.9661L48.3396 98.2193L49.7542 98.3143C50.9646 98.3967 51.9142 99.3322 52.0147 100.541L52.1307 101.954L52.3839 101.952L52.4789 100.538C52.5613 99.3273 53.4967 98.3778 54.7059 98.2773L56.1188 98.1612L56.1169 97.908L54.7024 97.8131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.904 192.697C100.299 192.652 99.8241 192.191 99.7774 191.587L99.7158 190.883L99.5892 190.884L99.5382 191.588C99.4935 192.194 99.0327 192.668 98.428 192.715L97.725 192.777L97.7259 192.903L98.4298 192.954C99.0352 192.999 99.51 193.46 99.5567 194.065L99.6182 194.768L99.7448 194.767L99.7959 194.063C99.8406 193.457 100.301 192.983 100.906 192.936L101.609 192.874L101.608 192.748L100.904 192.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.719 137.849C297.381 137.751 296.331 136.717 296.228 135.396L296.092 133.842L295.812 133.844L295.7 135.4C295.601 136.738 294.582 137.787 293.246 137.89L291.692 138.026L291.694 138.306L293.25 138.419C294.588 138.518 295.637 139.536 295.741 140.872L295.876 142.426L296.156 142.424L296.269 140.869C296.368 139.531 297.386 138.481 298.723 138.378L300.277 138.242L300.275 137.962L298.719 137.849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.347 54.5013C341.742 54.4566 341.267 53.9959 341.22 53.3912L341.159 52.6881L341.032 52.6891L340.981 53.393C340.936 53.9983 340.476 54.4731 339.871 54.5199L339.168 54.5814L339.169 54.708L339.873 54.759C340.478 54.8038 340.953 55.2645 341 55.8692L341.061 56.5722L341.188 56.5713L341.239 55.8674C341.283 55.262 341.744 54.7873 342.349 54.7405L343.052 54.679L343.051 54.5524L342.347 54.5013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.669 29.5249C235.859 29.465 235.223 28.8481 235.16 28.0385L235.078 27.0971L234.908 27.0984L234.84 28.0408C234.78 28.8514 234.163 29.4871 233.354 29.5497L232.412 29.632L232.414 29.8016L233.356 29.8699C234.167 29.9298 234.802 30.5467 234.865 31.3563L234.947 32.2976L235.117 32.2964L235.185 31.3539C235.245 30.5434 235.862 29.9077 236.672 29.8451L237.613 29.7627L237.612 29.5932L236.669 29.5249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.683 180.285C328.649 180.145 327.048 178.567 326.878 176.536L326.685 174.209L326.431 174.211L326.273 176.54C326.133 178.574 324.556 180.176 322.524 180.346L320.197 180.539L320.199 180.792L322.529 180.951C324.563 181.09 326.164 182.668 326.334 184.699L326.527 187.026L326.78 187.024L326.939 184.695C327.078 182.661 328.656 181.06 330.688 180.89L333.015 180.696L333.013 180.443L330.683 180.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.228 169.096C347.143 169.016 346.293 168.178 346.209 167.108L346.099 165.848L345.872 165.85L345.781 167.111C345.701 168.195 344.875 169.046 343.792 169.13L342.532 169.24L342.534 169.467L343.795 169.558C344.88 169.638 345.73 170.464 345.814 171.547L345.924 172.806L346.151 172.805L346.242 171.544C346.322 170.459 347.148 169.609 348.231 169.525L349.491 169.415L349.489 169.188L348.228 169.096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.397 28.3643C200.447 28.3011 199.703 27.5681 199.625 26.6191L199.533 25.5156L199.336 25.517L199.259 26.6219C199.196 27.5719 198.463 28.3159 197.514 28.3933L196.411 28.486L196.412 28.6829L197.517 28.759C198.467 28.8223 199.211 29.5552 199.288 30.5042L199.381 31.6078L199.578 31.6063L199.654 30.5015C199.717 29.5515 200.45 28.8075 201.399 28.73L202.503 28.6374L202.501 28.4404L201.397 28.3643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3702 164.263C31.4202 164.2 30.6762 163.467 30.5988 162.518L30.5061 161.414L30.3092 161.415L30.2331 162.52C30.1698 163.47 29.4369 164.214 28.4879 164.292L27.3843 164.384L27.3858 164.581L28.4906 164.657C29.4406 164.721 30.1846 165.454 30.2621 166.403L30.3547 167.506L30.5517 167.505L30.6278 166.4C30.691 165.45 31.424 164.706 32.3729 164.628L33.4765 164.536L33.4751 164.339L32.3702 164.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6266 40.833C87.6766 40.7698 86.9326 40.0368 86.8551 39.0879L86.7625 37.9843L86.5656 37.9858L86.4894 39.0906C86.4262 40.0406 85.6932 40.7846 84.7443 40.8621L83.6407 40.9547L83.6421 41.1516L84.747 41.2278C85.697 41.291 86.441 42.024 86.5184 42.9729L86.6111 44.0765L86.808 44.075L86.8841 42.9702C86.9474 42.0202 87.6803 41.2762 88.6293 41.1988L89.7329 41.1061L89.7314 40.9092L88.6266 40.833Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_24303_21508)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 194,
    r: 60,
    fill: "#316CEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_24303_21508",
    x: -16,
    y: 0,
    width: 388,
    height: 388,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67,
    result: "effect1_foregroundBlur_24303_21508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24303_21508",
    x1: 179.251,
    y1: 220.903,
    x2: 179.251,
    y2: -86.5547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D7FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#85D7FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#85D7FF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#85D7FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#85D7FF",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24303_21508",
    x1: 162.174,
    y1: 223.904,
    x2: 57.017,
    y2: -65.0123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D7FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#85D7FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#85D7FF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#85D7FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#85D7FF",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24303_21508",
    x1: 147.163,
    y1: 232.629,
    x2: -50.4736,
    y2: -2.9049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D7FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#85D7FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#85D7FF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#85D7FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#85D7FF",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_24303_21508",
    x1: 136.04,
    y1: 245.869,
    x2: -130.231,
    y2: 92.1377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D7FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#85D7FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#85D7FF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#85D7FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#85D7FF",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_24303_21508",
    x1: 196.32,
    y1: 223.953,
    x2: 301.476,
    y2: -64.9633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D7FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#85D7FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#85D7FF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#85D7FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#85D7FF",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_24303_21508",
    x1: 211.397,
    y1: 232.532,
    x2: 409.031,
    y2: -2.99814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D7FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#85D7FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#85D7FF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#85D7FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#85D7FF",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_24303_21508",
    x1: 222.513,
    y1: 245.901,
    x2: 488.788,
    y2: 92.1676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D7FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#85D7FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#85D7FF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#85D7FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#85D7FF",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsBgImage);
export default __webpack_public_path__ + "static/media/RewardsBGImage.d86ef300d23b292b2a09b77cd044bb0d.svg";
export { ForwardRef as ReactComponent };